import { FormField } from "@ab.uitools/ui-library/components/FormField";
import { Input } from "@ab.uitools/ui-library/components/Input";
import { useFormProps } from "@ab.uitools/ui-library/hooks/useFormProps";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  defaultValue: string;
  onNameChange: (value: string) => void;
}

export const RenameBeneficiaryForm = ({ defaultValue, onNameChange }: Props) => {
  const { t } = useTranslation();
  const { reset } = useFormProps();

  useEffect(() => {
    reset?.({ name: defaultValue });
  }, [defaultValue]);

  return (
    <FormField
      name="name"
      errorMessageIcon="infoFilled"
      As={(props) => (
        <Input
          {...props}
          required
          label={t("beneficiary.renameModal.name")}
          placeholder={t("beneficiary.renameModal.enterName")}
          maxCount={50}
          maxLength={50}
          onChange={(e) => {
            props.onChange?.(e);
            onNameChange(e.target.value);
          }}
        />
      )}
    />
  );
};
